// extracted by mini-css-extract-plugin
export default {"AddressBookSearchResult":"_AddressBookSearchResult--FU9UO","Company":"_Company--yVQ1D","Label":"_Label--T5yga","Icon":"_Icon--hsP94","Title":"_Title--POfP3"};